/**
 * Operations Insights Layout — h-screen flex column: AppBar header, scrolling
 * main, version footer (same shell as Site Organizer).
 */

import { ReactNode } from 'react';
import { Header } from './Header';
import { APP_VERSION, BUILD_DATE, COPYRIGHT_YEAR, COMPANY_NAME } from '../../../config/version';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="h-screen bg-gray-50 dark:bg-gray-900 flex flex-col overflow-hidden">
      <Header />
      <main className="flex-1 overflow-auto">
        {children}
      </main>
      <footer className="flex-shrink-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 py-2 px-6">
        <div className="flex flex-col sm:flex-row items-center justify-between text-xs text-gray-500 dark:text-gray-400 gap-1">
          <p>&copy; {COPYRIGHT_YEAR} {COMPANY_NAME}. All rights reserved.</p>
          <p>Version {APP_VERSION} &middot; {BUILD_DATE}</p>
        </div>
      </footer>
    </div>
  );
}

export default Layout;
